import { render } from "./contentView.vue?vue&type=template&id=915fa2fa&scoped=true"
import script from "./contentView.vue?vue&type=script&lang=js"
export * from "./contentView.vue?vue&type=script&lang=js"

import "./contentView.vue?vue&type=style&index=0&id=915fa2fa&lang=scss&scoped=true"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915fa2fa"]])

export default __exports__